import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { RouteProps } from 'react-router-dom';

import Person from '../../../components/person/person';
import DataStore from '../../store/DataStore';
import messages from '../messages';
import { GENDER_TYPES } from '../../../constants';
import classNames from 'classnames';
interface IDataStore {
  dataStore?: DataStore;
}

const Gender: React.SFC<RouteProps & IDataStore> = ({ dataStore }) => {
  return (
    <div className={classNames('c-bubble__content')}>
      <FormattedMessage {...messages.gender} />
      <div className="o-flex o-flex--wrap o-flex--justify-space-around o-flex--align-center u-margin-top-medium u-margin-horizontal-auto u-2-of-3-at-small u-1-of-1-at-medium">
        {GENDER_TYPES.map(g => (
          <Person
            key={g}
            gender={g}
            onClick={() => dataStore.setGender(g)}
            selected={g == dataStore.gender}
          />
        ))}
      </div>
    </div>
  );
};

export default inject('dataStore')(observer(Gender));



// WEBPACK FOOTER //
// ./src/containers/fitting/components/Gender.tsx